import { ScreenLoading, Table, TableContainer } from '@ui-components/neo.tax';

import { useAllTaxDocuments } from '@neo.tax/rd/hooks';
import { type TaxDocument } from '@neo.tax/shared';

import { useTaxFormColumns } from './tax-form-table.columns';

export const TaxFormTable = (): React.ReactElement => {
  const { loading: loadingAllTaxDocuments, taxDocuments } = useAllTaxDocuments();
  const taxFormColumns = useTaxFormColumns();

  if (loadingAllTaxDocuments) {
    return <ScreenLoading />;
  }
  return (
    <TableContainer>
      <Table<TaxDocument> columns={taxFormColumns} data={taxDocuments} />
    </TableContainer>
  );
};
